<template>
  <modal
      @close="$emit('close')"
      class="custom-popup-modal custom-popup medium-size"
  >
    <template slot="header">
      {{ $t('common_stockNotify.localization_value.value') }}
    </template>
    <template slot="body">
      <div class="custom-popup__content">
        <div class="address-editing__row custom-row">
          <div class="custom-col">
            <label class="cursor-pointer d-flex mt-2 mb-1">
              <DefaultCheckbox
                  :value="StockNotify.data.notify"
                  @input="(val) => StockNotify.data.notify = val"
              />
              {{ $t('common_stockNotifyMe.localization_value.value') }}
            </label>
          </div>
          <div class="custom-col custom-col--50 custom-col--xs-100">
            <DefaultInput
                v-bind:class="{'ui-no-valid': StockNotify.validation.minNumber}"
                :error="StockNotify.validation.minNumber"
                :errorTxt="$t(`${StockNotify.validationTranslate.minNumber}.localization_value.value`)"
                :label="$t('common_stockNotifyMinNum.localization_value.value')"
                :type="'text'"
                v-model="StockNotify.data.minNumber"
            />
          </div>
          <div class="custom-col">
            <template v-for="(item, index) in StockNotify.data.emails">
              <div class="d-flex mb-3 custom-col--75"
                   :key="index">
                <DefaultInput
                    class="w-100"
                    v-bind:class="{'ui-no-valid': item.validation.email}"
                    :error="item.validation.email"
                    :errorTxt="$t(`${item.validationTranslate.email}.localization_value.value`)"
                    :label="$t('common_email.localization_value.value')"
                    :type="'text'"
                    v-model="item.data.email"
                />

                <MainButton
                    class="ml-3"
                    :value="$t('common_delete.localization_value.value')"
                    @click.native="deleteEmail(index)"
                />
              </div>
            </template>


            <MainButton
                class="mt-3 mb-5"
                :value="$t('common_AddNew.localization_value.value')"
                @click.native="addNewEmail"
            />

          </div>

        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="custom-popup__btn align-items-center d-flex flex-wrap">
        <span
            class="site-link site-link--alt custom-popup__btn-i mr-4 mt-3 mb-3"
            @click="$emit('close')"
        >
             {{ $t('common_cancel.localization_value.value') }}
        </span>

        <MainButton
            :value="$t('common_save.localization_value.value')"
            @click.native="save"
        />
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../../../../commonModals/Modal";
import DefaultCheckbox from "@/components/UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import {StockNotify} from "@/components/modules/ProductsModule/models/StockNotify";
import MainButton from "@/components/UI/buttons/MainButton/MainButton";

export default {
  name: "SendNotifyProductCount",
  components: {
    MainButton,
    DefaultInput,
    DefaultCheckbox,
    Modal,
  },

  data() {
    return {
      StockNotify: new StockNotify(),
    }
  },

  mounted() {
    this.$store.dispatch('getStockAlertSettings').then(response => {
      this.StockNotify.setItem(this.getRespData(response))
    })
  },

  methods: {
    addNewEmail() {
      this.StockNotify.addEmail()
    },

    deleteEmail(index) {
      this.StockNotify.deleteEmail(index)
    },

    save() {
      if(!this.StockNotify.validateItem()) {
        return
      }

      let data = this.StockNotify.prepareSave()

      this.$store.dispatch('changeStockAlertSettings', data).then(response => {
        switch (this.getResponseStatus(response)) {
          /**
           * Success
           */
          case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
            this.openNotify('success', 'common_notificationRecordChanged')
            this.$emit('close')
            break
          }
          /**
           * Validation Error
           */
          case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
            let errors = response.response.data.errors;
            this.notifyErrorHelper(errors)
            break
          }
          /**
           * Undefined Error
           */
          default: {
            this.openNotify('error', 'common_notificationUndefinedError')
          }
        }
      })

    },
  }
}
</script>

<style lang="scss">
.send-email-popup .modal-component__inner {
  max-width: 518px;
}

.mh-225 {
  max-width: 390px;

  textarea {
    min-height: 225px;
    padding-right: 15px;
  }
}
</style>
